import styled from 'styled-components';
import MaterialAvatar from '@material-ui/core/Avatar';

export const MeetingIntro = styled.div`
  height: 100%;
  height: calc(100vh - 5rem);
  background-color: ${props => props.color};
  padding: 0px 20px;
  text-align: center;


  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    margin-top: -50px;
    color: #fff;

    .title {
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: 600;
      display: inline-block;
    }

    .name {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      margin: 5px 0px 10px;
    }

    .countdown {
      display: inline-block;
      font-size: 2rem;
      margin-left: 0.5rem;
    }

    .position {
      font-size: 12px;
      font-weight: 600;
    }

    .overview {
      font-size: 12px;
    }
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
`;

export const UserAvatar = styled(MaterialAvatar)`
   && {
    width: 120px;
    height: 120px;
    display: inline-block;

    &.text-avatar {
      font-size: 72px;
      padding-top: 10px;
    }
   }
`;



// WEBPACK FOOTER //
// ./src/routes/ZoomMeeting/components/styles.js